import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { MenuItem, Select, FormControl, InputBase } from "@mui/material";
import ConfirmationDialog from "../ConfirmationDialog";
import LabelPreview from "../LabelPreview";
import { useQuery } from "react-query";
import axiosInstance from "../../helpers/AxiosInstance";
import { Box } from "@mui/material";
const StyledSelect = styled(InputBase)(() => ({
  ".MuiInputBase-input": {
    fontFamily: "cairo",
    display: "flex",
    alignItems: "center", // عموديًا
    justifyContent: "center", // أفقيًا
    gap: "5px",
    border: "1px solid #001C4C",
    fontSize: 18,
    padding: "8px 10px",
    width: "130px",
    height: "25px",
    borderRadius: "5px",
    fontWeight: "900",
    backgroundColor: "white",
    boxShadow: "0px 3px 6px #0000005E",
    color: "#001C4C",
    textAlign: "center", // محاذاة النص داخل العنصر
  },
  ".MuiSelect-iconOutlined": {
    color: "var(--primary-color)",
    right: "10px",
  },
}));

export default function NewPrintBtn({ data, print, setLoading, style }) {
  const instance = axiosInstance();
  const [label, setLabel] = useState(null);
  const { data: labelData } = useQuery(
    "getLabels",
    async () => {
      const response = await instance.get("GetPDFTemplates");

      return response.data;
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  setLoading = setLoading ? setLoading : () => {};
  const { t } = useTranslation("uploadExcel");
  const [value, setValue] = React.useState("");
  const [openPreview, setOpenPreview] = useState(false);
  const handleChange = (event) => {
    const showPreview = async () => {
      setOpenPreview(true);
      setLabel(
        labelData?.find((label) => label.templateID === event.target.value)
      );
    };
    if (data.length > 0 || data.toString().length > 0) {
      if (print === "shipments") {
        showPreview().then(() => {
          setValue("");
        });
      } else {
        showPreview().then(() => {
          setValue("");
        });
      }
    }
    // do the export action
  };
  return (
    <Box
      sx={{
        position: "relative",
        top: "-195px",
        borderRadius: "5px",
        marginRight: "50px",
        ...(style || {}),
        "@media (max-width:1280px)": {
          marginRight: "20px", // تلغي المارجن عند العرض 1280 أو أقل
        },
      }}
    >
      <ConfirmationDialog id="ringtone-menu" keepMounted />
      <FormControl style={style}>
        <Select
          input={<StyledSelect defaultValue={""} />}
          value={value}
          id="export"
          onChange={handleChange}
          displayEmpty
          disableunderline="true"
          inputProps={{ "aria-label": "Without label" }}
        >
          <MenuItem value="" disabled>
            <span>{t("export_pdf")}</span>
          </MenuItem>
          {labelData?.map((label) => (
            <MenuItem key={label.templateID} value={label.templateID}>
              {label.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <LabelPreview
        data={data}
        label={label}
        open={openPreview}
        setOpen={setOpenPreview}
      />
    </Box>
  );
}
